export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";